export { default as ContactCenterPerDayReportFilters } from '@/views/pages/reports/contact-center-per-day/components/ContactCenterPerDayReportFilters.vue';
